<template>
  <section>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="secondary"
          class="secondary-font-color"
          v-bind="attrs"
          v-on="on"
          :disabled="bookBtnDisabled"
          @click.stop="onBookBtnClick"
          ><span> {{ $translate('ADD') }} </span>
        </v-btn>
        <!-- <v-badge
            large
            :content="getProductCount"
            :value="getProductCount"
            color="secondary"
          > -->

        <!-- <v-icon class="primary-font-color" medium> mdi-plus-thick</v-icon> -->

        <!-- </v-badge> -->
      </template>
      <span>{{ $translate('ADD') }}</span>
    </v-tooltip>
    <h5 v-if="getProductCount > 0 && !isMobile" class="pt-2">
      <span class="text--secondary"
        >{{ getProductCount }} {{ $translate('SELECTED') }}</span
      >
    </h5>
  </section>
</template>
<script>
import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';
import { SHOPPING_CONTAINER } from '@/shared/constants';
export default {
  name: 'ProfessionalViewProductAddToCart',
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    selectedItem: {
      type: Object,
      default: () => {},
    },
    disableBtn: Boolean,
  },
  emits: ['book'],
  data() {
    return {
      shoppingCart: {
        ShoppingListId: SHOPPING_CONTAINER.ShoppingCart,
        ShoppingListName: this.$translate('SHOPPING_CART_NAME'),
      },
      selectedShoppingList: {},
      shoppingCartCounter: [],
      productsInCart: [],
    };
  },
  mounted() {
    this.initListSelection();
    this.initOrders();
  },
  watch: {
    orders() {
      this.initOrders();
    },
  },
  computed: {
    ...mapState('shoppingCart', {
      orders: (state) => state.orders,
    }),
    userLoggedIn() {
      return this.$store.getters['auth/isValid'];
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },

    bookBtnDisabled() {
      if (this.disableBtn) return true;
      if (
        this.selectedShoppingList == null ||
        this.selectedShoppingList.ShoppingListId == null
      ) {
        //   // Didn't pick a list
        return true;
      }
    },
    getProductCount() {
      let quantity = 0;

      if (this.productsInCart.length < 0) this.initOrders();
      for (let i = 0; i < this.productsInCart.length; i++) {
        let obj = this.productsInCart[i];
        if (obj.ProductId === this.product.Id) {
          if (obj.ProductType !== 'Weighted') {
            quantity += Number(obj.Quantity);
          } else {
            quantity += 1;
          }
        }
      }
      return quantity;
    },
  },
  methods: {
    initListSelection() {
      this.product = this.product;
      // Shopping cart only
      this.disableBtn = this.disableBtn;
      this.selectedShoppingList = { ...this.shoppingCart };
    },
    initOrders() {
      this.shoppingCartCounter = [];
      if (this.orders.length > 0) {
        this.shoppingCartCounter = cloneDeep(this.orders);
      } else {
        this.productsInCart = [];
      }
      if (this.shoppingCartCounter.length > 0) {
        this.productsInCart = this.shoppingCartCounter[0].Products;
      }
    },
    onBookBtnClick() {
      const list = { ...this.selectedShoppingList };
      this.$emit('book', list);
    },
    onLoginBtnClick() {
      this.$emit('login');
    },
  },
};
</script>
